<template>
  <div>
    <CallCenterSearch></CallCenterSearch>
    <CallCenterAEDList></CallCenterAEDList>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CallCenterSearch from "@/components/searchTips.vue";
import CallCenterAEDList from "@/components/listTips.vue";
export default {
  name: "v-tip-os",
  components: {
    CallCenterSearch,
    CallCenterAEDList
  },
  computed: {
    ...mapState("tips", ["parameters"])
  },
  methods: {
    updateParameters() {
      Object.keys(this.$route.query).forEach(key => {
        switch (key) {
          case "aed":
          case "address":
          case "fadder": {
            this.$set(this.parameters, key, this.$route.query[key].split(","));
            break;
          }
          default: {
            const filterKeys = Object.keys(this.$store.state.tips.filters);
            this.$set(
              this.parameters,
              key,
              filterKeys.includes(key)
                ? this.$route.query[key]
                : isNaN(this.$route.query[key])
                ? this.$route.query[key]
                : parseInt(this.$route.query[key], 10)
            );
          }
        }
      });
    }
  },
  mounted() {
    this.unsubscribeParametersMutations = this.$store.subscribe(mutation => {
      switch (mutation.type) {
        case "tips/updateParameters":
          {
            const parametersQuery = {};
            Object.keys(this.parameters).forEach(key => {
              switch (key) {
                case "aed":
                case "address":
                case "fadder": {
                  if (this.parameters[key].length > 0) {
                    parametersQuery[key] = this.parameters[key].toString();
                  }
                  break;
                }
                default: {
                  if (this.parameters[key]) {
                    parametersQuery[key] = this.parameters[key];
                  }
                }
              }
            });
            this.$router.replace({ query: parametersQuery });
          }
          break;
      }
    });
  },
  created() {
    this.updateParameters();
  },
  beforeDestroy() {
    this.unsubscribeParametersMutations();
  }
};
</script>
